import { useEffect, useState } from "react";
import { IFilter } from "../../../../types";
import { formatDate } from "../../../../../../utils/generalFormat";
import {Button, Col, Container, Label, SecondaryButton} from "../../../../styles";
import LoadingOverlay from "../../../../../../components/LoadingOverlay";
import { Row } from "antd";
import { Field, Form, Formik } from "formik";
import { FormValuesHistory } from "../../types";
import HistoryAnticipationService from "../../service/historyAnticipationService";
import { can, PortalPermissions } from "../../../../../../config/permissions";

export const FormFilter: React.FC<IFilter> = (props: IFilter) => {
  const { getFilters } = props;
  const [isLoading] = useState(false);
  const [dateType, setDateType] = useState<"text" | "date">("text");
  const historyAnticipationService = new HistoryAnticipationService();
  const [isLoadingPage, setIsLoading] = useState(false);

  const getInitialValue = (): FormValuesHistory => {
    const today = new Date();
    const initDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      0,
      0,
      0
    );
    const finishDate = new Date(
      initDate.getFullYear(),
      initDate.getMonth(),
      initDate.getDate(),
      23,
      59,
      59
    );

    return {
      initDate: formatDate(initDate),
      finishDate: formatDate(finishDate),
      merchantId: ""
    };
  };

  const handleChangeInitialDate = (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = e.target;
    setFieldValue("initDate", value);
  };

  const handleChangeFinalDate = (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = e.target;
    const date = new Date(`${value}T23:59:59`);
    setFieldValue("finishDate", formatDate(date));
  };

  const handleDateFocus = () => {
    setDateType("date");
  };

  useEffect(() => {
    getAnticipations(getInitialValue());
  }, []);

  const getAnticipations = async (submit: any) => {
    let finishDate = submit.finishDate;
    if (finishDate) {
      const date = new Date(finishDate);
      if (
        date.getHours() === 0 &&
        date.getMinutes() === 0 &&
        date.getSeconds() === 0
      ) {
        date.setHours(23, 59, 59, 0);
        finishDate = formatDate(date);
      }
    }

    getFilters(submit);
    return submit;
  };

    const handleDownload = async (filter?: FormValuesHistory) => {
      setIsLoading(true);
      const response = await historyAnticipationService.downloadHistoryAnticipationXls(filter);

      if (response) {
        const objectUrl = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = "Histórico de Antecipação.xlsx"; // Nome do arquivo
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      }
      setIsLoading(false);
    };

  return (
    <Container style={{ padding: "0px" }}>
      <LoadingOverlay show={isLoading} relative />

      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik
        initialValues={getInitialValue()}
        onSubmit={async (values: any) => {
          await getAnticipations(values);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <Row gutter={16}>
              <Col>
                <input
                  type={dateType}
                  onChange={(e) => handleChangeInitialDate(e, setFieldValue)}
                  onFocus={handleDateFocus}
                  name="initDate"
                  placeholder="Data de recebimento inicial "
                  step="1"
                />
              </Col>
              <Col>
                <input
                  type={dateType}
                  onChange={(e) => handleChangeFinalDate(e, setFieldValue)}
                  onFocus={handleDateFocus}
                  name="finishDate"
                  placeholder="Data de recebimento final"
                  step="1"
                />
              </Col>

              <Col>
                <Field
                  type="text"
                  name="merchantId"
                  placeholder="Cód. Lojista"
                />
              </Col>

              <Col>
                <SecondaryButton htmlType="submit">
                  Consultar
                </SecondaryButton>
              </Col>
            </Row>
            <Row>
              <Col>
                {can(PortalPermissions.cobrancas.historicoAntecipacao.exportar) && (
                  <Button
                    onClick={() => handleDownload(values)}
                    style={{
                      marginBottom: "12px",
                      marginRight: "24px",
                      width: "150px",
                      alignSelf: "start",
                    }}
                  >
                    Download xlsx
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
};
